import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.6667 7.99984H3.33334" stroke="white" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M9.33334 11.3333L12.6667 8" stroke="white" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M9.33334 4.6665L12.6667 7.99984" stroke="white" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;